import axios from 'axios'

const instance = axios.create({
  baseURL: 'http://api.corridabradesco.com.br/api/',
  // baseURL: 'http://bradesco.test/api/',
  // baseURL: 'http://192.168.15.24:8000/api',
  headers: {
    'Content-Type': 'application/json',
     Accept: 'application/json',
  }
})

export default {

  sendMessage(message) {
    return instance.post('mail', message)
  },

  run(message) {
    return instance.post('run', message)
  },

  walk(message) {
    return instance.post('walk', message)
  },

  relay(message) {
    return instance.post('relay', message)
  },

  kid(message) {
    return instance.post('kid', message)
  },

  checkEmployer(code) {
    return instance.get(`func/${code}`)
  },

  result(code) {
    return instance.get(`result/${code}`)
  },

  results(tipo) {
    return instance.get(`result?TIPO=${tipo}`)
  }

}
